import type { RequestFn } from "./request";

export type EnsureStarterSkillsResult = {
  installedSlugs: string[];
};

export function createStarterSkillsClient({ request }: { request: RequestFn }) {
  return {
    // NOTE (Ezra, 2026-07-24): no in-repo caller; kept so editor builds from the previous release keep working through a rolling deploy.
    ensure: ({ projectId }: { projectId: string }) => {
      return request<EnsureStarterSkillsResult>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/starter-skills/ensure`,
      });
    },
  };
}
